import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiError } from "../lib/api";
import { Lightning, CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";

export default function VerifyEmail() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setMessage(t("auth.verify_missing_token")); return; }
    (async () => {
      try {
        await api.get("/auth/verify-email", { params: { token } });
        setStatus("ok");
      } catch (err) {
        setStatus("error");
        setMessage(formatApiError(err));
      }
    })();
  }, [params, t]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-[#050505]" data-testid="verify-email-page">
      <div className="w-full max-w-lg text-center">
        <Link to="/" className="flex items-center justify-center gap-2 mb-10">
          <Lightning size={28} weight="fill" className="text-[#E30613]" />
          <span className="font-display text-2xl uppercase font-black">FitAgenda <span className="text-[#E30613]">CH</span></span>
        </Link>
        <div className="border border-white/10 bg-[#0A0A0A] p-10">
          {status === "loading" && (
            <>
              <CircleNotch size={56} className="mx-auto text-zinc-400 animate-spin" />
              <p className="mt-6 text-sm text-zinc-400 uppercase tracking-widest">{t("auth.verify_loading")}</p>
            </>
          )}
          {status === "ok" && (
            <>
              <CheckCircle size={56} weight="duotone" className="text-[#00FF66] mx-auto" />
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#00FF66] font-bold mt-6">{t("auth.verify_ok_tag")}</div>
              <h1 className="font-display text-3xl uppercase font-black mt-2" data-testid="verify-ok-title">{t("auth.verify_ok_title")}</h1>
              <p className="text-sm text-zinc-300 mt-4 leading-relaxed">{t("auth.verify_ok_body")}</p>
              <Link to="/login" className="inline-block mt-8 bg-[#E30613] hover:bg-[#FF1A27] text-white uppercase tracking-[0.2em] font-bold px-8 py-3" data-testid="verify-ok-login-btn">
                {t("auth.login_action")}
              </Link>
            </>
          )}
          {status === "error" && (
            <>
              <XCircle size={56} weight="duotone" className="text-[#E30613] mx-auto" />
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#E30613] font-bold mt-6">{t("auth.verify_err_tag")}</div>
              <h1 className="font-display text-3xl uppercase font-black mt-2" data-testid="verify-err-title">{t("auth.verify_err_title")}</h1>
              <p className="text-sm text-zinc-300 mt-4 leading-relaxed">{message}</p>
              <Link to="/login" className="inline-block mt-8 text-xs uppercase tracking-widest text-[#E30613] hover:text-white font-bold" data-testid="verify-err-back-link">
                ← {t("common.back")}
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
